import Summary from "./summary.css"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { BarChart, Bar } from "recharts";
import { PieChart, Pie, Cell } from "recharts";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// images
// import impression from "../../assets/images/group_1.png";
// import ctr from "../../assets/images/CTR.png";
// import earningImg from "../../assets/images/earning.png";  
// import date from "../../assets/images/date_1.png";
import {
  FiDollarSign,
  FiCalendar,
  FiTrendingUp,
  FiBarChart2,
} from "react-icons/fi";
import axios from "axios";
// chart parameters
// const earningsData = [
//     { publisher: "20-feb-2025", earnings: 5000 },
//     { publisher: "21-feb-2025", earnings: 7000 },
//     { publisher: "22-feb-2025", earnings: 6000 },
//     { publisher: "23-feb-2025", earnings: 8000 },
//     { publisher: "24-feb-2025", earnings: 7500 },
//   ];
//   const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#0088FE"];

const SummaryPanel = () => {
  const pubId = localStorage.getItem("account_id");
  const getFormattedDate = (daysAgo = 0)=>{
    const date  = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date.toISOString().split("T")[0];
  }
  const [revenue, setRevenue] = useState("");
  const [reChartData, setReChartData] = useState([]);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(getFormattedDate(7));
  const [endDate, setEndDate] = useState(getFormattedDate(1));
  const [reportData, setReportData] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  
  const navigate = useNavigate();

  const adEarningsData = async ()=>{
    const token = localStorage.getItem("token");
    // console.log(token);
    if(!token){
      navigate("/");
    }

    try {
      const earningRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/dashboard`, {
        headers:{
          // Authorization: `Bearer ${localStorage.getItem("token")}`,``
          "Authorization": `Bearer ${token}`,
          "Accept":"application/json",
          // "Access-Control-Allow-Origin" : '*'
        },
      });
      // const earningResTwo = earningRes.toFixed(2)
      setRevenue(earningRes.data.data);
      // console.log(earningRes.data.data);      
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  }

  const chartData = async ()=>{
    try {
      const token = localStorage.getItem("token");
      if(!token){
        console.error("No token found! User not authenticated.");
        return;
      }      
      const chartRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/impressionRevenue`, {
        headers:{
          "Authorization": `Bearer ${token}`,
          "Accept":"application/json",
          // "Access-Control-Allow-Origin" : '*'
        },
        // withCredentials: true,
      });      
      // console.log("API Response:", chartRes.data.data);

      const transformedData = chartRes.data.data.map(barData=>({
        date:barData.date,
        impression:barData.impressions || 0,
        revenue:barData.revenue.toFixed(5) || 0,
      }));

      // console.log("Transformed Data:", transformedData);

      setReChartData(transformedData);

    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  }
  // reporting
  const allDaysReport = async ()=>{
    try {
      const token = localStorage.getItem("token");
      if(!token){
        console.error("No token found! User not authenticated.");
      return;
      }   
      const dayWiseReportRes = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/pub/reportByAdUnit?page=1`, 
        { startDate, endDate },
      {
        headers:{
          "Authorization": `Bearer ${token}`,
          "Accept":"application/json",
          // "Access-Control-Allow-Origin" : '*'
        }
    }
  );
      // console.log(dayWiseReportRes.data); 
      setReportData(dayWiseReportRes?.data?.data?.data || []);
      setDataColumns(dayWiseReportRes?.data?.data?.columns);
      console.log(dataColumns);
      

    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  }
  // define which columns you want to display
  const allowedColumns = ["p_ad_display_name", "requests", "page_views", "imp", "ctr", "pubRev", "pub_eCPM"];
  // filter the API columns before rendering
  // const visibleColumns = dataColumns?.filter(col => allowedColumns.includes(col));
      let visibleColumns = dataColumns?.filter(col => {
      if (col === "page_views" && pubId !== "c79a2d5f-2dc7-41c7-8927-463bc022327e") {
        return false; // hide page_views for other publishers
      }
      return allowedColumns.includes(col);;
    });
  const headerMapping = {
      p_ad_display_name: "Ad Unit",
      imp: "Impressions",
      ctr: "CTR",
      pubRev: pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? "Publisher Rev ($)" : "Publisher Rev ($)",
      requests:"Request",
      page_views:"Page Views",
      pub_eCPM: pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? "PubeCPM($)" : "PubeCPM($)",
  };
  useEffect(()=>{
    adEarningsData();
    chartData();
    allDaysReport();
    const pubId = localStorage.getItem("account_id");
    if (pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      navigate("/reporting");
    }
  }, []);
    return(
        <section className="dashboardBody">
          <h2 style={{fontSize:"20px", marginBottom:"20px"}}>Dashboard</h2>
        {/* <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4"> */}
          {/* old boxes layout code  */}
        {/* {  */}
          {/* revenue.length > 0 ?  */}
          <>
          {/* first col start */}
           {/* <div className="col-lg-3 col-md-3 col-sm-4">
             <div className={`card shadow-none border bg-gradient-start-1-0 h-100`}>
               <div className="card-body p-20">
                 <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                   <div>
                     <p className="fw-medium text-light mb-1">Earnings</p>
                     <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[0]?.earning.toFixed(2)}`:`$${revenue[0]?.earning.toFixed(2)}`}</h6>
                   </div>
                   <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                     <img src={impression} />
                   </div>
                 </div>
                 <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                       <img src={date} /> <span>Yesterday</span>
                 </div>
               </div>
             </div>
           </div> */}
           {/* second col start */}
           {/* <div className="col-lg-3 col-md-3 col-sm-4">
             <div className={`card shadow-none border bg-gradient-start-1-1 h-100`}>
               <div className="card-body p-20">
                 <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                   <div>
                     <p className="fw-medium text-light mb-1">Earnings</p>
                     <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[1]?.earning.toFixed(2)}` : `$${revenue[1]?.earning.toFixed(2)}`}</h6>
                   </div>
                   <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                     <img src={impression} />
                   </div>
                 </div>
                 <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                       <img src={date} /> <span>Seven Days</span>
                 </div>
               </div>
             </div>
          </div> */}
          {/* third col start */}
          {/* <div className="col-lg-3 col-md-3 col-sm-4">
             <div className={`card shadow-none border bg-gradient-start-1-2 h-100`}>
               <div className="card-body p-20">
                 <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                   <div>
                     <p className="fw-medium text-light mb-1">Earnings</p>
                     <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[2]?.earning.toFixed(2)}` : `$${revenue[2]?.earning.toFixed(2)}`}</h6>
                   </div>
                   <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                     <img src={impression} />
                   </div>
                 </div>
                 <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                       <img src={date} /> <span>This Month</span>
                 </div>
               </div>
             </div>
          </div> */}
          {/* fourth col start */}
          {/* <div className="col-lg-3 col-md-3 col-sm-4">
             <div className={`card shadow-none border bg-gradient-start-1-3 h-100`}>
               <div className="card-body p-20">
                 <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                   <div>
                     <p className="fw-medium text-light mb-1">Earnings</p>
                     <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[3]?.earning.toFixed(2)}` : `$${revenue[3]?.earning.toFixed(2)}`}</h6>
                   </div>
                   <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                     <img src={impression} />
                   </div>
                 </div>
                 <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                       <img src={date} /> <span>Last Month</span>
                 </div>
               </div>
             </div>
          </div> */}
           </>

          {/* : null */}
        {/* } */}
          {/* card end */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Earnings</p>
                  <h6 className="mb-0">55,0000</h6>
                </div>
                <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                <img src={ctr} />
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> Last 7 days
              </p>
            </div>
          </div>
        </div> */}
          {/* card end  */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Earnings</p>
                  <h6 className="mb-0">₹ 15,00000</h6>
                </div>
                <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                <img src={earningImg} />
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> This month
              </p>
            </div>
          </div>
        </div> */}
           {/* card end */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-4 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Total Income</p>
                  <h6 className="mb-0">$42,000</h6>
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> Last 10 days users
              </p>
            </div>
          </div>
        </div> */}
          {/* card end */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-5 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Total Expense</p>
                  <h6 className="mb-0">$30,000</h6>
                </div>
                <div className="w-50-px h-50-px bg-red rounded-circle d-flex justify-content-center align-items-center">
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> Last 10 days users
              </p>
            </div>
          </div>
        </div> */}
      {/* </div> */}
            {/* new boxes layout code  */}
      {/* Earnings Summary Cards */}
          <div className="row g-4 summary-card-row">
            {revenue.length > 0 ? (
              <>
                {/* Yesterday */}
                <div className="col-xl-3 col-lg-6 col-md-6">
                  <div className="summary-card summary-card-purple">
                    <div className="summary-card-content">
                      <div className="summary-card-info">
                        <span className="summary-card-title">
                          TOTAL EARNINGS
                        </span>

                        <h3 className="summary-card-value">
                          {pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e"
                            ? `$${revenue[0]?.earning?.toFixed(2)}`
                            : `$${revenue[0]?.earning?.toFixed(2)}`}
                        </h3>

                        <div className="summary-card-period">
                          <FiCalendar />
                          <span>Yesterday</span>
                        </div>
                      </div>

                      <div className="summary-card-icon">
                        <FiDollarSign />
                      </div>

                      <FiDollarSign className="summary-card-bg-icon" />
                    </div>
                  </div>
                </div>

                {/* Seven Days */}
                <div className="col-xl-3 col-lg-6 col-md-6">
                  <div className="summary-card summary-card-blue">
                    <div className="summary-card-content">
                      <div className="summary-card-info">
                        <span className="summary-card-title">
                          TOTAL EARNINGS
                        </span>

                        <h3 className="summary-card-value">
                          {pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e"
                            ? `$${revenue[1]?.earning?.toFixed(2)}`
                            : `$${revenue[1]?.earning?.toFixed(2)}`}
                        </h3>

                        <div className="summary-card-period">
                          <FiCalendar />
                          <span>Seven Days</span>
                        </div>
                      </div>

                      <div className="summary-card-icon">
                        <FiTrendingUp />
                      </div>

                      <FiTrendingUp className="summary-card-bg-icon" />
                    </div>
                  </div>
                </div>

                {/* This Month */}
                <div className="col-xl-3 col-lg-6 col-md-6">
                  <div className="summary-card summary-card-orange">
                    <div className="summary-card-content">
                      <div className="summary-card-info">
                        <span className="summary-card-title">
                          TOTAL EARNINGS
                        </span>

                        <h3 className="summary-card-value">
                          {pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e"
                            ? `$${revenue[2]?.earning?.toFixed(2)}`
                            : `$${revenue[2]?.earning?.toFixed(2)}`}
                        </h3>

                        <div className="summary-card-period">
                          <FiCalendar />
                          <span>This Month</span>
                        </div>
                      </div>

                      <div className="summary-card-icon">
                        <FiBarChart2 />
                      </div>

                      <FiBarChart2 className="summary-card-bg-icon" />
                    </div>
                  </div>
                </div>

                {/* Last Month */}
                <div className="col-xl-3 col-lg-6 col-md-6">
                  <div className="summary-card summary-card-green">
                    <div className="summary-card-content">
                      <div className="summary-card-info">
                        <span className="summary-card-title">
                          TOTAL EARNINGS
                        </span>

                        <h3 className="summary-card-value">
                          {pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e"
                            ? `$${revenue[3]?.earning?.toFixed(2)}`
                            : `$${revenue[3]?.earning?.toFixed(2)}`}
                        </h3>

                        <div className="summary-card-period">
                          <FiCalendar />
                          <span>Last Month</span>
                        </div>
                      </div>

                      <div className="summary-card-icon">
                        <FiDollarSign />
                      </div>

                      <FiDollarSign className="summary-card-bg-icon" />
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
      {/* chart section start */}
    {/* <div className="p-6 bg-gray-100 min-h-screen mt-5">
      <div className="bg-white p-4 rounded-2xl shadow-md">
        <h3 className="text-lg font-semibold mb-4 mt-5" style={{fontSize:"20px"}}>Earnings Day Wise</h3>
        {
          reChartData?.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                  <BarChart data={reChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }} barSize={55}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" tick={{ fill: "#444444", fontSize: 14, fontWeight: "bold" }} />
                    <YAxis yAxisId="left" orientation="left" label={{ value: "Revenue", angle: -90, position: "insideLeft", textAnchor: "middle", fill:"#487fff", fontSize:25,fontWeight:"bold"}} tick={{ fill: "#555555", fontSize: 14, fontWeight: "bold" }} />
                    <YAxis yAxisId="right" orientation="right" label={{ value: "Impressions", angle: -90, dy: -100, position: "insideRight", textAnchor: "middle", fill:"#c3891e", fontSize:25,fontWeight:"bold"}} tick={{ fill: "#555555", fontSize: 14, fontWeight: "bold" }} />
                    <Tooltip 
                      contentStyle={{ backgroundColor: "#222", color:"#ffffff", borderRadius: "8px", border: "none" }} 
                      itemStyle={{ color: "#fff" }} 
                      wrapperStyle={{ outline: "none" }}
                      cursor={{ fill: "rgba(142, 216, 132, 0.3)" }}
                    />
                    <Bar yAxisId="left" dataKey="revenue" fill="#6720ef" name="Revenue" />
                    <Bar yAxisId="right" dataKey="impression" fill="#c3be1eaa" name="Impressions" />
                  </BarChart>
                </ResponsiveContainer>
          )
                :null
        }

      </div>
    </div> */}
    {/* ================= CHART SECTION ================= */}
<div className="summary-chart-card">

  <div className="summary-chart-header">
    <div>
      <h3>Earnings Day Wise</h3>
      <p>Revenue and impressions for the last 7 days</p>
    </div>
  </div>

  <div className="summary-chart-body">
    {reChartData?.length > 0 ? (
      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={reChartData}
          margin={{
            top: 15,
            right: 25,
            left: 10,
            bottom: 5,
          }}
          barGap={8}
          barCategoryGap="22%"
        >

          <CartesianGrid
            strokeDasharray="4 4"
            vertical={false}
            stroke="#e9edf5"
          />

          <XAxis
            dataKey="date"
            tick={{
              fill: "#64748b",
              fontSize: 12,
              fontWeight: 600,
            }}
            axisLine={false}
            tickLine={false}
            dy={10}
          />

          <YAxis
            yAxisId="left"
            orientation="left"
            tick={{
              fill: "#64748b",
              fontSize: 12,
            }}
            axisLine={false}
            tickLine={false}
            width={45}
          />

          <YAxis
            yAxisId="right"
            orientation="right"
            tick={{
              fill: "#64748b",
              fontSize: 12,
            }}
            axisLine={false}
            tickLine={false}
            width={55}
          />

          <Tooltip
            cursor={{
              fill: "rgba(99, 102, 241, 0.05)",
            }}
            contentStyle={{
              background: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              boxShadow: "0 8px 25px rgba(15, 23, 42, 0.12)",
              padding: "10px 14px",
            }}
            labelStyle={{
              color: "#0f172a",
              fontWeight: 700,
              marginBottom: "6px",
            }}
            itemStyle={{
              fontSize: "13px",
              fontWeight: 600,
            }}
          />

          <Legend
            verticalAlign="top"
            align="right"
            height={35}
            iconType="circle"
            wrapperStyle={{
              fontSize: "13px",
              fontWeight: 600,
              color: "#475569",
            }}
          />

          <Bar
            yAxisId="left"
            dataKey="revenue"
            name="Revenue"
            fill="#4F46E5"
            radius={[6, 6, 0, 0]}
            maxBarSize={42}
          />

          <Bar
            yAxisId="right"
            dataKey="impression"
            name="Impressions"
            fill="#F59E0B"
            radius={[6, 6, 0, 0]}
            maxBarSize={42}
          />

        </BarChart>
      </ResponsiveContainer>
    ) : (
      <div className="summary-no-chart-data">
        <div className="no-chart-icon">📊</div>
        <h4>No earnings data available</h4>
        <p>There is no data available for the selected period.</p>
      </div>
    )}
  </div>

</div>
  {/* reporting */}
    {/* <h3 className="text-lg font-semibold mb-4 mt-5" style={{fontSize:"20px"}}>Ad Unit Performance (Last 7 days)</h3>
    <table className="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            {
               visibleColumns?.length > 0 ?
                <th>SN</th> : ""
            }
            {
              visibleColumns?.map((tableHead, index)=>(
              <th scope="col" key={index}>{headerMapping[tableHead] || {tableHead}}</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            reportData?.length > 0 ? (
              
              reportData.map((adReportData, adReportDataInd) =>(
                <tr key={adReportDataInd}>
                  <td>{adReportDataInd + 1}</td>
                  {dataColumns.includes("p_ad_display_name") && <td>{adReportData.p_ad_display_name}</td>}
                  {dataColumns.includes("requests") && <td>{adReportData.requests}</td>} 
                  {dataColumns.includes("page_views") && pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" && (<td>{adReportData.page_views}</td>)} 
                  {dataColumns.includes("imp") && <td>{adReportData.imp}</td>}
                  {dataColumns.includes("ctr") && <td>{adReportData.ctr != null ? adReportData.ctr : "0"}</td>}
                  {dataColumns.includes("pubRev") && <td>{adReportData.pubRev ?.toFixed(2) || "0"}</td>}
                  {dataColumns.includes("pub_eCPM") && <td>{adReportData.pub_eCPM ?.toFixed(2) || "0"}</td>}
                </tr> 
              ))           
            )
            :
            <tr>
              <td colSpan="12" className="text-center">No data available</td>
            </tr>
            
          }
        </tbody>
      </table> */}
      {/* ================= AD UNIT PERFORMANCE ================= */}
        <div className="summary-table-card">

          <div className="summary-table-header">
            <div>
              <h3>Ad Unit Performance</h3>
              <p>Performance summary for the last 7 days</p>
            </div>
          </div>

          <div className="summary-table-wrapper">

            <table className="table summary-performance-table">

              <thead>
                <tr>

                  {visibleColumns?.length > 0 && (
                    <th>SN</th>
                  )}

                  {visibleColumns?.map((tableHead, index) => (
                    <th scope="col" key={index}>
                      {headerMapping[tableHead] || tableHead}
                    </th>
                  ))}

                </tr>
              </thead>

              <tbody>

                {reportData?.length > 0 ? (

                  reportData.map((adReportData, adReportDataInd) => (

                    <tr key={adReportDataInd}>

                      <td className="summary-sn">
                        {adReportDataInd + 1}
                      </td>

                      {dataColumns.includes("p_ad_display_name") && (
                        <td className="summary-ad-name">
                          {adReportData.p_ad_display_name}
                        </td>
                      )}

                      {dataColumns.includes("requests") && (
                        <td>
                          {adReportData.requests}
                        </td>
                      )}

                      {dataColumns.includes("page_views") &&
                        pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" && (
                          <td>
                            {adReportData.page_views}
                          </td>
                        )
                      }

                      {dataColumns.includes("imp") && (
                        <td>
                          {adReportData.imp}
                        </td>
                      )}

                      {dataColumns.includes("ctr") && (
                        <td>
                          {adReportData.ctr != null
                            ? adReportData.ctr
                            : "0"}
                        </td>
                      )}

                      {dataColumns.includes("pubRev") && (
                        <td className="summary-revenue">
                          {adReportData.pubRev != null
                            ? adReportData.pubRev.toFixed(2)
                            : "0"}
                        </td>
                      )}

                      {dataColumns.includes("pub_eCPM") && (
                        <td>
                          {adReportData.pub_eCPM != null
                            ? adReportData.pub_eCPM.toFixed(2)
                            : "0"}
                        </td>
                      )}

                    </tr>

                  ))

                ) : (

                  <tr>
                    <td
                      colSpan="12"
                      className="summary-no-data"
                    >
                      <div>
                        <span>📊</span>
                        <p>No data available</p>
                      </div>
                    </td>
                  </tr>

                )}

              </tbody>

            </table>

          </div>

        </div>
      </section>
      
    )
}

export default SummaryPanel;